import { Gender, InvoiceStatus, POSProductType } from "@/types/enums";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvoiceItem {
  item_id: number;
  item_type: POSProductType;
  sale_tax_id: number;
  income_category_id: number;
  description: string;
  quantity: number;
  price: number;
  tax_rate: number;
  discount: number;
  sub_total: number;
  tax_type: string;
  tax_name: string;
  total: number;
  tax_amount: number;
  booking_date: string; 
}

interface Payment {
  payment_method_id: number;
  payment_method: string;
  amount: number;
}

interface Invoice {
  mainRefund_id: number;
  member_id: number;
  member_name: string;
  member_email: string;
  member_address: string;
  member_nic: string;
  member_gender: Gender;
  notes: string;
  status: InvoiceStatus;
  staff_id: number;
  staff_name: string;
  payment_date: string; // ISO date string (e.g., "2025-04-28")
  total: number;
  sub_total: number;
  tax_amount: number;
  discount: number;
  invoice_date: string;
  total_quantity: number;
  items: InvoiceItem[];
  created_at: string; // ISO date string
  counter_id: number;
  batch_id: number;
  receipt_number: string;
  transaction_type: string;
  payments: Payment[];
  change_amount: number;
  amount_received: number;
  member_tax_group_id?: number;
}

interface InvoiceState {
  invoice: Invoice | null;
}

const initialState: InvoiceState = {
  invoice: null,
};

const walletSclice = createSlice({
  name: "walletSlice",
  initialState,
  reducers: {
    setWalletInvoice: (state, action: PayloadAction<Invoice | null>) => {
      state.invoice = action.payload;
    },
    resetWalletInvoice: (state) => {
      state.invoice = null;
    },
  },
});

export const { setWalletInvoice, resetWalletInvoice } = walletSclice.actions;

export default walletSclice.reducer;
